import { brandColors } from '../../design-system/tokens';

/** Visible keyboard focus for every control on the GUS Weekly page. */
export const focusRing = {
  '&.Mui-focusVisible, &:focus-visible': {
    outline: `2px solid ${brandColors.silaTeal}`,
    outlineOffset: 2,
  },
};

/** The portal theme rounds text fields to 8px; this page is square. */
export const squareField = { '& .MuiOutlinedInput-root': { borderRadius: 0 } };

export const squarePaper = { sx: { borderRadius: 0 } };
